var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-input"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.5 30.75H24.75C25.4793 30.75 26.1788 30.4603 26.6945 29.9445C27.2103 29.4288 27.5 28.7293 27.5 28V10.125L20.625 3.25H8.25C7.52065 3.25 6.82118 3.53973 6.30546 4.05546C5.78973 4.57118 5.5 5.27065 5.5 6V11.5",
    stroke: "#2D3958",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.25 3.25V8.75C19.25 9.47935 19.5397 10.1788 20.0555 10.6945C20.5712 11.2103 21.2707 11.5 22 11.5H27.5",
    stroke: "#2D3958",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.75 21.125H16.5",
    stroke: "#2D3958",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.375 25.25L16.5 21.125L12.375 17",
    stroke: "#2D3958",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileInput);
export default __webpack_public_path__ + "static/media/file-input.84ed936b6f139c07409df42e18bfccb5.svg";
export { ForwardRef as ReactComponent };